const APITableColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 70
  },
  {
    title: 'Token Name',
    dataIndex: 'tokenName',
    slot: 'tokenName',
    width: 250
  },
  {
    title: 'Status',
    slot: 'status',
    width: 100
  },
  {
    title: 'Created',
    dataIndex: 'created',
    slot: 'created',
    width: 150
  },
  {
    title: 'Last Active',
    dataIndex: 'lastUsed',
    slot: 'lastUsed',
    width: 150
  },
  {
    title: 'Actions',
    key: 'actions',
    slot: 'actions',
    width: 250
  }
];

export {APITableColumn};
